import { useQuery } from "@tanstack/react-query"
import { productsQuery } from "../lib/productsQuery"

export function useGetProducts(...args: Parameters<typeof productsQuery>) {
  return useQuery(productsQuery(...args))
}
